import CircuitEmail from "./circuit-email";
import CircuitName from "./circuit-name";
import CircuitTelephone from "./circuit-telephone";

export default {
    Email: CircuitEmail,
    Name: CircuitName,
    Phone: CircuitTelephone,
}